import React, { Fragment } from 'react';
import { Icon, ICONS, PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';
import { InfoElement } from '../../open-questionnaires-details.styles';

export const HealthInsuranceCardName = ({
  file,
  healthInsuranceCardName,
  handleModalOpen,
  t,
}: {
  t: Function;
  healthInsuranceCardName?: string;
  handleModalOpen: () => void;
  file?: {
    location: string;
    filename: string;
  };
}) => {
  return (
    <div>
      <InfoElement key={'healthInsuranceCardName'}>
        <Typography weight="bold">{`${t(
          `employee:questionnaire.paymentAndInsurance.labels.healthInsuranceCardName`
        )}`}</Typography>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {healthInsuranceCardName ? healthInsuranceCardName : '-'}
        </Typography>
      </InfoElement>
      <InfoElement key={'healthInsuranceCard'}>
        <Typography weight="bold">{`${t(
          `employee:questionnaire.paymentAndInsurance.labels.healthInsuranceCard`
        )}`}</Typography>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {file?.location ? (
            <Fragment>
              <a target="_blank" rel="noopener noreferrer" href={file?.location} title={'file'}>
                {file?.filename}
              </a>
              <Icon
                icon={ICONS.downloadSolid}
                rightMargin={false}
                color={PLATFORM_THEME_COLORS.primary.blue}
                size={16}
              />
            </Fragment>
          ) : (
            '-'
          )}
        </Typography>
      </InfoElement>
      <Typography
        style={{
          cursor: 'pointer',
        }}
        onClick={handleModalOpen}
        fontColor={PLATFORM_THEME_COLORS.primary.blue}
      >
        {t('settings:healthInsurance.buttons.addHealthInsurance')}
      </Typography>
    </div>
  );
};

export default HealthInsuranceCardName;
